import React, { FC } from 'react';
import { SBadge } from './Badge.style';
import { TBadgeProps } from './Badge.type';

export const Badge: FC<TBadgeProps> = (props) => {
  return <SBadge {...props} />;
};
